var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regular-filters"},_vm._l((_vm.regularFiltersData),function(filterData){return _c('regular-filter',_vm._b({key:_vm.getFilterKey(filterData),on:{"change":function($event){return _vm.handleFilterChange($event, filterData.type)}}},'regular-filter',filterData,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }